import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual } from 'recompose'
import Dropzone from 'react-dropzone'

import FileInputPreview from './FileInputPreview'
import translate from '@/i18n/translate'

export class FileInput extends Component {
  static propTypes = {
    accept: PropTypes.string,
    children: PropTypes.element,
    disableClick: PropTypes.bool,
    input: PropTypes.object,
    labelMultiple: PropTypes.string,
    labelSingle: PropTypes.string,
    maxSize: PropTypes.number,
    minSize: PropTypes.number,
    multiple: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    placeholder: PropTypes.node,
  }

  static defaultProps = {
    addLabel: true,
    addField: true,
    labelMultiple: 'i18n.input.file.upload_several',
    labelSingle: 'i18n.input.file.upload_single',
    multiple: false,
    onUpload: () => {},
  }

  constructor(props) {
    super(props)
    let files = props.input.value || []
    if (!Array.isArray(files)) {
      files = [files]
    }

    this.state = {
      files: files.map(this.transformFile),
    }
  }

  componentWillReceiveProps(nextProps) {
    let files = nextProps.input.value || []
    if (!Array.isArray(files)) {
      files = [files]
    }

    this.setState({ files: files.map(this.transformFile) })
  }

  onDrop = files => {
    const updatedFiles = this.props.multiple
      ? [...this.state.files, ...files.map(this.transformFile)]
      : [...files.map(this.transformFile)]

    this.setState({ files: updatedFiles })
    this.props.input.onChange(updatedFiles)
  }

  onRemove = file => () => {
    const filteredFiles = this.state.files.filter(stateFile => !shallowEqual(stateFile, file))

    this.setState({ files: filteredFiles })
    this.props.input.onChange(filteredFiles)
  }

  // turn a browser dropped file structure into expected structure
  transformFile = file => {
    if (!(file instanceof File)) {
      return file
    }

    const { source, title } = React.Children.toArray(this.props.children)[0].props

    const transformedFile = {
      rawFile: file,
      [source]: file.preview,
    }

    if (title) {
      transformedFile[title] = file.name
    }

    return transformedFile
  }

  label() {
    const { translate, placeholder, labelMultiple, labelSingle } = this.props

    if (placeholder) {
      return placeholder
    }

    if (this.props.multiple) {
      return <p>{translate(labelMultiple)}</p>
    }

    return <p>{translate(labelSingle)}</p>
  }

  render() {
    const {
      accept,
      children,
      disableClick,
      maxSize,
      minSize,
      multiple,
      classes,
      theme,
    } = this.props
    const styles = {}
    if (this.state.files.length && !multiple) {
      styles.background = 'transparent'
    }

    return (
      <div className={classes}>
        {children && (
          <div className="previews">
            {this.state.files.map((file, index) => (
              <FileInputPreview
                key={index}
                file={file}
                onRemove={this.onRemove(file)}
                theme={theme}
              >
                {React.cloneElement(children, {
                  record: file,
                })}
              </FileInputPreview>
            ))}
          </div>
        )}
        <Dropzone
          onDrop={this.onDrop}
          accept={accept}
          disableClick={disableClick}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
          style={styles}
          className={theme['drop-zone']}
        >
          <If condition={multiple || !this.state.files.length}>{this.label()}</If>
        </Dropzone>
      </div>
    )
  }
}

export default translate(FileInput)



// WEBPACK FOOTER //
// ./ui/Input/FileInput.js